import { render } from "./list-link-client.vue?vue&type=template&id=5e0bce8c"
import script from "./list-link-client.vue?vue&type=script&lang=js"
export * from "./list-link-client.vue?vue&type=script&lang=js"

import "./list-link-client.vue?vue&type=style&index=0&id=5e0bce8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__